import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-personal-data-policy',
    imports: [TranslateModule],
    templateUrl: './personal-data-policy.component.html',
    styleUrl: './personal-data-policy.component.scss'
})
export class PersonalDataPolicyComponent {}